import {Link} from 'react-router-dom';
import './Nav.css';

function Nav() {
    return (
        <div className="navbar">
            <div className="nav-links">
                <Link to="/" className="nav-link">Home</Link>
                <Link to="/about" className="nav-link">About</Link>
                <Link to="/resume" className="nav-link">Resume</Link>
            </div>
        </div>
    );
};

export default Nav; 
